import { ProgressStatus, TrackingContentSection } from '@jbhi-fi/apis/src/orderTrackingThemeApi/types';

export const DEFAULT_TITLE = 'ESTIMATED DELIVERY';
export const BULKY_SCHEDULED_TITLE = 'DELIVERY SCHEDULED FOR';
export const ORDER_COMPLETE_TITLE = 'DONE DEAL!';
export const COLLECTION_TODAY_TITLE = 'COLLECTION DAY';
export const ORDER_COMPLETE_SUBTITLE = 'Enjoy your new purchase and thanks for shopping with us.';
export const VALID_ORDER_NUMBER_PREFIXES = {
  AU: ['JB-', 'JBD-AU'],
  NZ: ['JBNZ-', 'JBD-NZ'],
};

export const CANT_FIND_ORDER_ALERT: Exclude<TrackingContentSection['alert'], undefined> = {
  heading: "We can't find that order",
  type: 'warning',
  content: `Please check your order number and try again. Your order number is in the top right corner of your confirmation email.    

Note: Tracking in-store delivery purchases is not available yet.`,
};

export const BACK_ORDER_ALERT: Exclude<TrackingContentSection['alert'], undefined> = {
  heading: 'Your back order',
  subheader: 'Your item is being ordered from our supplier.',
  type: 'info',
  content: `Here's what to expect:\n1. Our customer service team will be in contact with a delivery estimate.\n2. Once we have your item we'll process and ship it.\n3. You'll get an email when it's been confirmed and on the way with a tracking link.`,
};
export const ORDER_CANCELLED_ALERT: Exclude<TrackingContentSection['alert'], undefined> = {
  heading: 'This order has been cancelled',
  type: 'error',
  content: `Looks like the order you’re trying to track has been cancelled. If this is incorrect, please [contact us](#).`,
};

export const DELIVERY_SHIPMENT_PROGRESSION: Array<ProgressStatus> = [
  'Confirmed',
  'Packed',
  'In transit',
  'Out for delivery',
  'Delivered',
];
export const CUSTOMER_COLLECT_SHIPMENT_PROGRESSION: Array<ProgressStatus> = [
  'Confirmed',
  'Ready to collect',
  'Collected',
];
export const UNTRACKED_SHIPMENT_PROGRESSION: Array<ProgressStatus> = ['Confirmed', 'Packed', 'In transit'];
export const UBER_SHIPMENT_PROGRESSION: Array<ProgressStatus> = [
  'Confirmed',
  'Packed',
  'Awaiting Uber pickup',
  'Out for delivery',
  'Delivered',
];
export const MARKETPLACE_SHIPMENT_PROGRESSION: Array<ProgressStatus> = [
  'Confirmed',
  'In transit',
  'Out for delivery',
  'Delivered',
];

export const BACK_ORDER_ETA_DISCLAIMER = "Date may change once we've received the item from the supplier.";

export const BACK_ORDER_DELAYED_ALERT: Exclude<TrackingContentSection['alert'], undefined> = {
  heading: 'Delayed',
  type: 'warning',
  content:
    "There's been a delay in receiving your back order item from the supplier. We'll send an update once we've got it.",
};
